var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockRotateDeprecated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 1.33333C11.6823 1.33333 14.6666 4.3177 14.6666 8C14.6666 11.6823 11.6823 14.6667 7.99998 14.6667C6.58592 14.6667 5.27081 14.224 4.19008 13.4713C3.81248 13.1849 3.71977 12.6875 3.98435 12.3099C4.24738 11.9323 4.7656 11.8411 5.14321 12.1042C5.9531 12.6693 6.93748 13 7.99998 13C10.7604 13 13 10.7604 13 8C13 5.21614 10.7604 2.99999 7.99998 2.99999C6.59633 2.99999 5.36977 3.55885 4.46352 4.46354L5.2656 5.26562C5.65883 5.65885 5.38019 6.33333 4.8255 6.33333H1.95831C1.61326 6.33333 1.33331 6.05468 1.33331 5.70833V2.84218C1.33331 2.28541 2.00649 2.00651 2.40024 2.40026L3.28592 3.28593C4.49217 2.08046 6.15883 1.33333 7.97654 1.33333H7.99998ZM7.99998 4.66666C8.34633 4.66666 8.62498 4.94531 8.62498 5.29166V7.74218L10.2943 9.43229C10.5599 9.67708 10.5599 10.0729 10.2943 10.2943C10.0729 10.5599 9.67706 10.5599 9.43227 10.2943L7.55727 8.41927C7.44008 8.32552 7.37498 8.16666 7.37498 8V5.29166C7.37498 4.94531 7.65363 4.66666 7.99998 4.66666Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockRotateDeprecated);
export default __webpack_public_path__ + "static/media/clock-rotate_deprecated.a246420f51d12229be488ebb023bdbe3.svg";
export { ForwardRef as ReactComponent };